import React from "react";

// Mui Styles
// import { styled } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";

// CSS
import "@/styles/page/systemSettingProductPage.css";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import { giveAwayManageTableColumn } from "@/config/tableColumnConfig";
import DataTable from "@/components/dataTable";

// Mui Icon
import DownloadIcon from "@mui/icons-material/Download";
import IconButton from "@mui/material/IconButton";
import { AddOutlined } from "@mui/icons-material";

//import generate csv library
import { CSVLink } from "react-csv";

// Fetch
import { getGiveawayManage } from "@/fetch/fetchGiveaway";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";
import { useCurrentAction } from "@/hooks/user";

const GiveAwayManagePage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  // Navigate
  const navigate = useNavigate();

  // States
  const [giveAwayData, setGiveAwayData] = React.useState([]);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const onCellClick = (data) => {
    if (data.field === "__check__") return;
    else {
      navigate(`edit/${data.id}`);
    }
  };

  const onAddClick = () => {
    navigate("create/");
  };

  // create a headers for generate csv file
  const headers = [
    { label: "id", key: "id" },
    { label: "m18_product_code", key: "m18_product_code" },
    { label: "item_brand", key: "item_brand" },
    { label: "item_name", key: "item_name" },
    { label: "item_unit_price", key: "item_unit_price" },
    { label: "is_active", key: "is_active" },
  ];

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      await getGiveawayManage().then((data) => {
        if (data && data.results) setGiveAwayData(data.data);
      });
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      selectedIndex={17}
      header="workLocationManagePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title="贈品管理"
        history={() => navigate(-1)}
        children={
          <div>
            {/* Add Record */}
            {actions?.create && (
              <IconButton component="label" onClick={onAddClick}>
                <AddOutlined />
              </IconButton>
            )}
            {actions?.download && (
              <CSVLink
                data={giveAwayData}
                filename={`Giveaway List - ${moment(Date.startDate).format(
                  "YYYY-MM-DD"
                )} to ${moment(Date.endDate).format("YYYY-MM-DD")} `}
                headers={headers}
              >
                <IconButton component="label">
                  <DownloadIcon />
                </IconButton>
              </CSVLink>
            )}
          </div>
        }
      />
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={giveAwayData}
            onCellClick={(params) => onCellClick(params)}
            columns={giveAwayManageTableColumn}
            pageSize={100}
            initialState={{
              sorting: {
                sortModel: [{ field: "brand_types_name", sort: "asc" }],
              },
            }}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default GiveAwayManagePage;
